import React from 'react';
import { Link } from 'react-router-dom';

import { Card, CardActionArea, CardContent, Grid } from '@mui/material';

type Props = {
  href: string;
  children: JsxNode;
};
export default function TileLink({ href, children }: Props) {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card>
        <CardActionArea component={Link} to={href}>
          <CardContent sx={{ height: 160 }}>{children}</CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
}
